<template>
  <div class="w-full h-full block">
    <h1 class="heading text-4xl my-6">Results</h1>
    <h3 class="font-main font-semibold text-xl my-4">
      Last Updated: 19:30 (GMT+1) 09/05/2020
    </h3>
    <table v-if="finishedUsers.length > 0" class="font-main my-6">
      <tr class="font-main text-center hover:bg-blue-200">
        <th @click="changeSortBy('position')">
          Pos.
          <up-down-arrows
            :active="sortBy === 'position'"
            :ascending="sortDirection === 'ASC'"
          />
        </th>
        <th @click="changeSortBy('name')">
          Name
          <up-down-arrows
            :active="sortBy === 'name'"
            :ascending="sortDirection === 'ASC'"
          />
        </th>

        <th @click="changeSortBy('score')">
          Score
          <up-down-arrows
            :active="sortBy === 'score'"
            :ascending="sortDirection === 'ASC'"
          />
        </th>
        <th @click="changeSortBy('time')">
          Time
          <up-down-arrows
            :active="sortBy === 'time'"
            :ascending="sortDirection === 'ASC'"
          />
        </th>
      </tr>
      <tbody is="transition-group" name="fade">
        <tr
          v-for="user of sortedUsers"
          :key="user.id"
          class="text-center odd:bg-blue-100 hover:bg-blue-200 font-main"
        >
          <td>{{ user.position }}</td>
          <td>{{ user.name }}</td>
          <td>{{ user.score }}</td>
          <td>{{ displayTime(user.time) }}</td>
        </tr>
      </tbody>
    </table>
    <h3 v-else class="font-main text-2xl my-4">No Results Yet</h3>
    <router-link class="button blue my-6" to="/forest/lockdown"
      >Return Home</router-link
    >
  </div>
</template>

<script>
import UpDownArrows from '@/components/UpDownArrows'
/*
import firebase from 'firebase/app'
import 'firebase/firestore'

const db = firebase.firestore()
*/
export default {
  components: {
    UpDownArrows,
  },

  data: function() {
    return {
      users: [
        {
          id: '1696',
          name: 'Naomi Thornton',
          score: 975,
          position: 1,
          time: 51040,
        },
        {
          id: '1262',
          name: 'Dominic Dakin',
          score: 935,
          position: 2,
          time: 50951,
        },
        {
          id: '1164',
          name: 'Philipp von Arx',
          score: 935,
          position: 3,
          time: 52789,
        },
        {
          id: '1197',
          name: 'Adam Methven',
          score: 915,
          position: 4,
          time: 66152,
        },
        {
          id: '1268',
          name: 'Kate McLuckie',
          score: 915,
          position: 5,
          time: 67191,
        },
        {
          id: '1031',
          name: 'River Edis-Smith',
          score: 910,
          position: 6,
          time: 76975,
        },
        {
          id: '1603',
          name: 'Torgny Lindström',
          score: 905,
          position: 7,
          time: 73776,
        },
        {
          id: '1391',
          name: 'Chris Evans',
          score: 900,
          position: 8,
          time: 35351,
        },
        {
          id: '1341',
          name: 'Ondrej Strelba',
          score: 900,
          position: 9,
          time: 73578,
        },
        {
          id: '1670',
          name: 'Jillian Devine',
          score: 900,
          position: 10,
          time: 122456,
        },
        {
          id: '1412',
          name: 'Mick Farrell',
          score: 895,
          position: 11,
          time: 33380,
        },
        {
          id: '1016',
          name: 'Jessica Halliday',
          score: 895,
          position: 12,
          time: 33599,
        },
        {
          id: '1784',
          name: 'Aurelie Andry',
          score: 895,
          position: 13,
          time: 42073,
        },
        {
          id: '1877',
          name: "Marie O'Donovan",
          score: 890,
          position: 14,
          time: 33111,
        },
        {
          id: '1313',
          name: 'Isobel Howard',
          score: 890,
          position: 15,
          time: 37646,
        },
        {
          id: '1207',
          name: 'Aimee Darley',
          score: 890,
          position: 16,
          time: 38394,
        },
        {
          id: '1044',
          name: 'Finlay Raynor',
          score: 890,
          position: 17,
          time: 39046,
        },
        {
          id: '1217',
          name: 'Marian Basset',
          score: 885,
          position: 18,
          time: 38655,
        },
        {
          id: '1851',
          name: 'Joe Parkinson',
          score: 885,
          position: 19,
          time: 40064,
        },
        {
          id: '1123',
          name: "Chris O'Donnell",
          score: 885,
          position: 20,
          time: 83824,
        },
        {
          id: '1075',
          name: 'Oscar Shepherd',
          score: 880,
          position: 21,
          time: 42813,
        },
        {
          id: '1614',
          name: 'Imogen Pieters',
          score: 880,
          position: 22,
          time: 45980,
        },
        {
          id: '1828',
          name: 'Kezia Jukes',
          score: 880,
          position: 23,
          time: 48304,
        },
        {
          id: '1079',
          name: 'Don Bayly',
          score: 880,
          position: 24,
          time: 52011,
        },
        {
          id: '1064',
          name: 'Fiona Hendrie',
          score: 880,
          position: 25,
          time: 52669,
        },
        {
          id: '1513',
          name: 'Abi Weeds',
          score: 880,
          position: 26,
          time: 54466,
        },
        {
          id: '1387',
          name: 'James Rogers',
          score: 880,
          position: 27,
          time: 88690,
        },
        {
          id: '1093',
          name: 'Helen Errington',
          score: 875,
          position: 28,
          time: 45863,
        },
        {
          id: '1367',
          name: 'Hugo Vaxelaire',
          score: 875,
          position: 29,
          time: 47942,
        },
        {
          id: '1728',
          name: 'Nicolas Mohn',
          score: 875,
          position: 30,
          time: 50478,
        },
        {
          id: '1585',
          name: 'Ursula Kadan',
          score: 875,
          position: 31,
          time: 55528,
        },
        {
          id: '1856',
          name: 'Gerry Browne',
          score: 870,
          position: 32,
          time: 56065,
        },
        {
          id: '1562',
          name: 'Sophie Jones',
          score: 870,
          position: 33,
          time: 58700,
        },
        {
          id: '1267',
          name: 'Finlay McLuckie',
          score: 870,
          position: 34,
          time: 61459,
        },
        {
          id: '1881',
          name: 'Philipp Haider',
          score: 865,
          position: 35,
          time: 56698,
        },
        {
          id: '1166',
          name: 'Clare Dallimore',
          score: 865,
          position: 36,
          time: 67774,
        },
        {
          id: '1027',
          name: 'Jo Shepherd',
          score: 860,
          position: 37,
          time: 61016,
        },
        {
          id: '1861',
          name: 'Noel Braun',
          score: 860,
          position: 38,
          time: 70483,
        },
        {
          id: '1876',
          name: 'Xavier Bregnac',
          score: 860,
          position: 39,
          time: 123044,
        },
        {
          id: '1531',
          name: 'Beccy Osborn',
          score: 850,
          position: 40,
          time: 25772,
        },
        {
          id: '1178',
          name: 'Ephraim Chuene ',
          score: 850,
          position: 41,
          time: 30642,
        },
        {
          id: '1056',
          name: 'Brad Connor',
          score: 850,
          position: 42,
          time: 31064,
        },
        {
          id: '1570',
          name: 'Helen Wheelwright',
          score: 850,
          position: 43,
          time: 76602,
        },
        {
          id: '1637',
          name: 'Mathias Lataste',
          score: 845,
          position: 44,
          time: 30270,
        },
        {
          id: '1524',
          name: 'Alexandra Danninger',
          score: 845,
          position: 45,
          time: 31832,
        },
        {
          id: '1763',
          name: 'Iona Scott',
          score: 845,
          position: 46,
          time: 34168,
        },
        {
          id: '1538',
          name: 'Hannah Hateley',
          score: 845,
          position: 47,
          time: 36209,
        },
        {
          id: '1065',
          name: 'Ian Hendrie',
          score: 845,
          position: 48,
          time: 38220,
        },
        {
          id: '1492',
          name: 'Bastian Danninger',
          score: 845,
          position: 49,
          time: 39511,
        },
        {
          id: '1526',
          name: 'Jane  Hunter',
          score: 845,
          position: 50,
          time: 43492,
        },
        {
          id: '1361',
          name: 'Ian Maxwell',
          score: 845,
          position: 51,
          time: 84126,
        },
        {
          id: '1483',
          name: 'Lyra Medlock',
          score: 840,
          position: 52,
          time: 32618,
        },
        {
          id: '1371',
          name: 'Basile Basset',
          score: 840,
          position: 53,
          time: 36849,
        },
        {
          id: '1706',
          name: 'Elizabeth Jackson',
          score: 840,
          position: 54,
          time: 39244,
        },
        {
          id: '1090',
          name: 'Rebecca McCreadie',
          score: 840,
          position: 55,
          time: 41090,
        },
        {
          id: '1060',
          name: 'Jennifer Rooney',
          score: 840,
          position: 56,
          time: 42113,
        },
        {
          id: '1073',
          name: 'Jon Shepherd',
          score: 840,
          position: 57,
          time: 44283,
        },
        {
          id: '1509',
          name: 'Hanne Robertson',
          score: 840,
          position: 58,
          time: 44285,
        },
        {
          id: '1092',
          name: 'Simon Errington',
          score: 840,
          position: 59,
          time: 45321,
        },
        {
          id: '1036',
          name: 'Andrew Stemp',
          score: 840,
          position: 60,
          time: 48303,
        },
        { id: '1628', name: 'Sam Todd', score: 840, position: 61, time: 78923 },
        {
          id: '1865',
          name: 'Leonne Hutchinson',
          score: 840,
          position: 62,
          time: 81263,
        },
        {
          id: '1432',
          name: 'Robin Strain',
          score: 840,
          position: 63,
          time: 83131,
        },
        {
          id: '1554',
          name: 'Anna Simkovics',
          score: 840,
          position: 64,
          time: 85148,
        },
        {
          id: '1055',
          name: 'Jamie Hayward',
          score: 840,
          position: 65,
          time: 92944,
        },
        {
          id: '1621',
          name: 'Steve Wilson',
          score: 835,
          position: 66,
          time: 41445,
        },
        {
          id: '1484',
          name: 'Eskarina Medlock',
          score: 835,
          position: 67,
          time: 42749,
        },
        {
          id: '1288',
          name: 'Gavan Winn',
          score: 835,
          position: 68,
          time: 43918,
        },
        {
          id: '1673',
          name: 'Monty Bratcher-Howard',
          score: 835,
          position: 69,
          time: 45619,
        },
        {
          id: '1287',
          name: 'Ewan Winn',
          score: 835,
          position: 70,
          time: 45636,
        },
        {
          id: '1174',
          name: 'Angus Ivory',
          score: 835,
          position: 71,
          time: 49103,
        },
        {
          id: '1167',
          name: 'Mike Pedley',
          score: 835,
          position: 72,
          time: 50262,
        },
        {
          id: '1479',
          name: 'Iain Stemp',
          score: 835,
          position: 73,
          time: 50355,
        },
        {
          id: '1421',
          name: 'Vanda Kralova',
          score: 835,
          position: 74,
          time: 78337,
        },
        {
          id: '1124',
          name: "Jake O'Donnell",
          score: 835,
          position: 75,
          time: 91455,
        },
        {
          id: '1270',
          name: 'John Britton',
          score: 835,
          position: 76,
          time: 136668,
        },
        {
          id: '1767',
          name: 'Poppy Chorlton',
          score: 830,
          position: 77,
          time: 43920,
        },
        {
          id: '1187',
          name: 'Ben Brown',
          score: 830,
          position: 78,
          time: 45205,
        },
        {
          id: '1594',
          name: 'Paul Todd',
          score: 830,
          position: 79,
          time: 45591,
        },
        {
          id: '1113',
          name: 'Tobias Danninger',
          score: 830,
          position: 80,
          time: 47932,
        },
        {
          id: '1841',
          name: 'Isla Overy',
          score: 830,
          position: 81,
          time: 48933,
        },
        {
          id: '1615',
          name: 'Erik Bonek',
          score: 830,
          position: 82,
          time: 54207,
        },
        {
          id: '1850',
          name: 'Andrew Bell',
          score: 830,
          position: 83,
          time: 88196,
        },
        {
          id: '1388',
          name: 'Zara Rogers',
          score: 825,
          position: 84,
          time: 46987,
        },
        {
          id: '1667',
          name: 'Dave Chaffey',
          score: 825,
          position: 85,
          time: 47254,
        },
        {
          id: '1482',
          name: 'Jolyon Medlock',
          score: 825,
          position: 86,
          time: 48057,
        },
        {
          id: '1541',
          name: 'Emma Currie',
          score: 825,
          position: 87,
          time: 50420,
        },
        {
          id: '1683',
          name: 'Joseph Goodwin',
          score: 825,
          position: 88,
          time: 50602,
        },
        {
          id: '1310',
          name: 'Andrew Twigg',
          score: 825,
          position: 89,
          time: 51725,
        },
        {
          id: '1744',
          name: 'Elena Gvozdeykova',
          score: 825,
          position: 90,
          time: 52597,
        },
        {
          id: '1553',
          name: 'Callum Crocker',
          score: 825,
          position: 91,
          time: 53659,
        },
        {
          id: '1099',
          name: 'James Laird',
          score: 825,
          position: 92,
          time: 59406,
        },
        {
          id: '1440',
          name: 'Colin Smith',
          score: 825,
          position: 93,
          time: 91563,
        },
        {
          id: '1186',
          name: 'Thierry Gueorgiou',
          score: 825,
          position: 94,
          time: 95950,
        },
        {
          id: '1221',
          name: 'Pauline Tryner',
          score: 825,
          position: 95,
          time: 99999,
        },
        {
          id: '1525',
          name: 'Angela Darley',
          score: 820,
          position: 96,
          time: 48240,
        },
        {
          id: '1602',
          name: 'Euan Tryner',
          score: 820,
          position: 97,
          time: 54278,
        },
        {
          id: '1014',
          name: 'Freddie Carcas',
          score: 820,
          position: 98,
          time: 57663,
        },
        {
          id: '1771',
          name: 'Matthew Wadey',
          score: 820,
          position: 99,
          time: 58719,
        },
        {
          id: '1848',
          name: 'John Brammer',
          score: 820,
          position: 100,
          time: 59412,
        },
        {
          id: '1238',
          name: 'Paul Pruzina',
          score: 820,
          position: 101,
          time: 61289,
        },
        {
          id: '1354',
          name: 'Marie Dingreville',
          score: 820,
          position: 102,
          time: 63215,
        },
        {
          id: '1810',
          name: 'Deirbhile Hassett',
          score: 815,
          position: 103,
          time: 59687,
        },
        {
          id: '1502',
          name: 'Kirsten Strain',
          score: 815,
          position: 104,
          time: 60144,
        },
        {
          id: '1333',
          name: 'Judith Bell',
          score: 815,
          position: 105,
          time: 62586,
        },
        {
          id: '1606',
          name: 'Nick Lightfoot',
          score: 815,
          position: 106,
          time: 63804,
        },
        {
          id: '1781',
          name: 'Hayley Collins',
          score: 815,
          position: 107,
          time: 64772,
        },
        {
          id: '1581',
          name: 'William Ivory',
          score: 815,
          position: 108,
          time: 112637,
        },
        {
          id: '1818',
          name: 'Ludo Lagenebre',
          score: 810,
          position: 109,
          time: 55722,
        },
        {
          id: '1012',
          name: 'Fay Walsh',
          score: 810,
          position: 110,
          time: 61838,
        },
        {
          id: '1878',
          name: 'Jacqueline Dakin',
          score: 810,
          position: 111,
          time: 63190,
        },
        {
          id: '1572',
          name: 'Jakob Wolfram',
          score: 810,
          position: 112,
          time: 63872,
        },
        {
          id: '1674',
          name: 'Harry Bratcher - Howard',
          score: 810,
          position: 113,
          time: 65503,
        },
        {
          id: '1655',
          name: 'Llewellyn McGivern',
          score: 810,
          position: 114,
          time: 67537,
        },
        {
          id: '1659',
          name: 'Pawel Bugajski',
          score: 810,
          position: 115,
          time: 69243,
        },
        {
          id: '1306',
          name: 'Sarah Rollins',
          score: 805,
          position: 116,
          time: 69419,
        },
        {
          id: '1153',
          name: 'James Hammond',
          score: 805,
          position: 117,
          time: 74083,
        },
        {
          id: '1414',
          name: 'Casper Skepp',
          score: 805,
          position: 118,
          time: 75921,
        },
        {
          id: '1747',
          name: 'Sara Dżumaga',
          score: 800,
          position: 119,
          time: 20208,
        },
        {
          id: '1883',
          name: 'Sergio Yañez',
          score: 800,
          position: 120,
          time: 21099,
        },
        {
          id: '1860',
          name: 'Isaac Oliver',
          score: 800,
          position: 121,
          time: 21547,
        },
        {
          id: '1015',
          name: 'Sarah Jones',
          score: 800,
          position: 122,
          time: 24929,
        },
        {
          id: '1682',
          name: 'Jonty Goodwin',
          score: 800,
          position: 123,
          time: 28599,
        },
        {
          id: '1596',
          name: 'Dmitry Ushakov',
          score: 800,
          position: 124,
          time: 30659,
        },
        {
          id: '1398',
          name: 'Stanimira Dimitrova',
          score: 800,
          position: 125,
          time: 31365,
        },
        {
          id: '1853',
          name: 'Philippa Allen',
          score: 800,
          position: 126,
          time: 31940,
        },
        {
          id: '1610',
          name: 'Michael Bishenden',
          score: 800,
          position: 127,
          time: 33705,
        },
        {
          id: '1021',
          name: 'Ben Mitchell',
          score: 800,
          position: 128,
          time: 34597,
        },
        {
          id: '1869',
          name: 'Keith Brown',
          score: 800,
          position: 129,
          time: 37312,
        },
        {
          id: '1188',
          name: 'Matija Razum',
          score: 800,
          position: 130,
          time: 72840,
        },
        {
          id: '1078',
          name: 'Rebecca Gray',
          score: 800,
          position: 131,
          time: 74235,
        },
        {
          id: '1020',
          name: 'Megan Carter-Davies',
          score: 800,
          position: 132,
          time: 79794,
        },
        {
          id: '1580',
          name: 'David Bunn',
          score: 800,
          position: 133,
          time: 81246,
        },
        {
          id: '1819',
          name: 'Tereza Smelikova',
          score: 800,
          position: 134,
          time: 81831,
        },
        {
          id: '1517',
          name: 'Roberto Larotella',
          score: 795,
          position: 135,
          time: 33246,
        },
        {
          id: '1231',
          name: 'Ffion Bricknell',
          score: 795,
          position: 136,
          time: 33897,
        },
        {
          id: '1846',
          name: 'Aaron Gaio',
          score: 795,
          position: 137,
          time: 36644,
        },
        {
          id: '1427',
          name: 'Duncan Currie',
          score: 795,
          position: 138,
          time: 37397,
        },
        {
          id: '1366',
          name: 'Malcolm Aldridge',
          score: 795,
          position: 139,
          time: 37748,
        },
        {
          id: '1206',
          name: 'Sarah Darley',
          score: 795,
          position: 140,
          time: 37982,
        },
        {
          id: '1382',
          name: 'Lone Brochmann',
          score: 795,
          position: 141,
          time: 44413,
        },
        {
          id: '1150',
          name: 'Kim Hadorn',
          score: 795,
          position: 142,
          time: 46412,
        },
        {
          id: '1672',
          name: 'Keith Willdig',
          score: 795,
          position: 143,
          time: 80866,
        },
        {
          id: '1629',
          name: 'Anna Todd',
          score: 795,
          position: 144,
          time: 81269,
        },
        {
          id: '1731',
          name: 'Graham Heap',
          score: 795,
          position: 145,
          time: 84142,
        },
        {
          id: '1470',
          name: 'Mairi Weir',
          score: 795,
          position: 146,
          time: 85750,
        },
        {
          id: '1830',
          name: 'Christine Glew',
          score: 795,
          position: 147,
          time: 125612,
        },
        {
          id: '1134',
          name: 'Alice Soulsby',
          score: 790,
          position: 148,
          time: 39295,
        },
        {
          id: '1451',
          name: 'Joe Sunley',
          score: 790,
          position: 149,
          time: 39761,
        },
        {
          id: '1510',
          name: 'Alan Halliday',
          score: 790,
          position: 150,
          time: 40937,
        },
        {
          id: '1590',
          name: 'Oscar Rowe',
          score: 790,
          position: 151,
          time: 41551,
        },
        {
          id: '1608',
          name: 'Robbie Lightfoot',
          score: 790,
          position: 152,
          time: 41832,
        },
        {
          id: '1880',
          name: 'Mark Foxwell',
          score: 790,
          position: 153,
          time: 76922,
        },
        {
          id: '1252',
          name: 'Jeremy Genar',
          score: 790,
          position: 154,
          time: 81462,
        },
        {
          id: '1831',
          name: 'Richard Gardner',
          score: 790,
          position: 155,
          time: 84083,
        },
        {
          id: '1003',
          name: 'Fiona Bunn',
          score: 790,
          position: 156,
          time: 84805,
        },
        {
          id: '1353',
          name: 'Heather Walton',
          score: 790,
          position: 157,
          time: 86326,
        },
        {
          id: '1638',
          name: 'Samuel Bartlett',
          score: 790,
          position: 158,
          time: 86449,
        },
        {
          id: '1567',
          name: 'Laura Ramstein',
          score: 790,
          position: 159,
          time: 91099,
        },
        {
          id: '1425',
          name: 'Veli-Matti Ylönen',
          score: 790,
          position: 160,
          time: 99682,
        },
        {
          id: '1866',
          name: 'Lucia Parga',
          score: 785,
          position: 161,
          time: 39936,
        },
        {
          id: '1365',
          name: 'Juliette Basset',
          score: 785,
          position: 162,
          time: 40907,
        },
        {
          id: '1089',
          name: 'Adam McCreadie',
          score: 785,
          position: 163,
          time: 41450,
        },
        {
          id: '1062',
          name: 'John Blatherwick',
          score: 785,
          position: 164,
          time: 42094,
        },
        {
          id: '1832',
          name: 'Philip Sorrell',
          score: 785,
          position: 165,
          time: 43459,
        },
        {
          id: '1838',
          name: 'Eunice Carter',
          score: 785,
          position: 166,
          time: 44088,
        },
        {
          id: '1052',
          name: 'Maja Robertson',
          score: 785,
          position: 167,
          time: 44667,
        },
        {
          id: '1795',
          name: 'Maremo Mphahlele',
          score: 785,
          position: 168,
          time: 47175,
        },
        {
          id: '1324',
          name: 'Claire Ward',
          score: 785,
          position: 169,
          time: 48041,
        },
        {
          id: '1286',
          name: 'Teresa Winn',
          score: 785,
          position: 170,
          time: 87924,
        },
        {
          id: '1550',
          name: 'Simon Crocker',
          score: 785,
          position: 171,
          time: 94929,
        },
        {
          id: '1422',
          name: 'Elias Schafer',
          score: 785,
          position: 172,
          time: 97711,
        },
        {
          id: '1654',
          name: 'Alicia McGivern',
          score: 780,
          position: 173,
          time: 45145,
        },
        {
          id: '1369',
          name: 'Hannah Gray',
          score: 780,
          position: 174,
          time: 50192,
        },
        {
          id: '1213',
          name: 'Finn Selmer Duguid',
          score: 780,
          position: 175,
          time: 51593,
        },
        {
          id: '1857',
          name: 'Niamh Browne',
          score: 780,
          position: 176,
          time: 52542,
        },
        {
          id: '1491',
          name: 'Tengfei Han',
          score: 780,
          position: 177,
          time: 54743,
        },
        {
          id: '1636',
          name: 'Lucie Lataste',
          score: 780,
          position: 178,
          time: 57068,
        },
        {
          id: '1204',
          name: 'Alastair Dunlop',
          score: 780,
          position: 179,
          time: 60021,
        },
        {
          id: '1551',
          name: 'Clare Crocker',
          score: 780,
          position: 180,
          time: 88277,
        },
        {
          id: '1739',
          name: 'Caroline Potter',
          score: 780,
          position: 181,
          time: 90593,
        },
        {
          id: '1666',
          name: 'Jamie Goddard',
          score: 780,
          position: 182,
          time: 93848,
        },
        {
          id: '1555',
          name: 'Aidan Smith',
          score: 780,
          position: 183,
          time: 95724,
        },
        {
          id: '1773',
          name: 'Sadhbh Hassett',
          score: 775,
          position: 184,
          time: 47840,
        },
        {
          id: '1760',
          name: 'Jon Wheatcroft',
          score: 775,
          position: 185,
          time: 50525,
        },
        {
          id: '1223',
          name: 'Freya Tryner',
          score: 775,
          position: 186,
          time: 51869,
        },
        {
          id: '1732',
          name: 'Alison Campbell',
          score: 775,
          position: 187,
          time: 52033,
        },
        {
          id: '1825',
          name: 'Ciara Keen',
          score: 775,
          position: 188,
          time: 53842,
        },
        {
          id: '1626',
          name: 'Oded Verbin',
          score: 775,
          position: 189,
          time: 56768,
        },
        {
          id: '1618',
          name: 'Caz Dudley',
          score: 775,
          position: 190,
          time: 60150,
        },
        {
          id: '1576',
          name: "Brendan O'Brien",
          score: 775,
          position: 191,
          time: 60784,
        },
        {
          id: '1300',
          name: 'Jon Cross',
          score: 775,
          position: 192,
          time: 100659,
        },
        {
          id: '1649',
          name: 'James Hayward',
          score: 775,
          position: 193,
          time: 102375,
        },
        {
          id: '1647',
          name: 'Daniel Weaver',
          score: 775,
          position: 194,
          time: 102763,
        },
        {
          id: '1586',
          name: 'Rachel Kirkland',
          score: 775,
          position: 195,
          time: 104791,
        },
        {
          id: '1280',
          name: 'Isia Basset',
          score: 770,
          position: 196,
          time: 49129,
        },
        {
          id: '1600',
          name: 'Troy Southall',
          score: 770,
          position: 197,
          time: 50380,
        },
        {
          id: '1583',
          name: 'Helen Nisbet',
          score: 770,
          position: 198,
          time: 52004,
        },
        {
          id: '1588',
          name: 'Rachael Rothman',
          score: 770,
          position: 199,
          time: 53347,
        },
        {
          id: '1811',
          name: 'Fionn Hassett',
          score: 770,
          position: 200,
          time: 55323,
        },
        {
          id: '1145',
          name: 'Robert King',
          score: 770,
          position: 201,
          time: 57990,
        },
        {
          id: '1126',
          name: 'Darren Baker',
          score: 770,
          position: 202,
          time: 62337,
        },
        {
          id: '1404',
          name: 'Bertie Kingsley',
          score: 770,
          position: 203,
          time: 64209,
        },
        {
          id: '1195',
          name: 'John Methven',
          score: 770,
          position: 204,
          time: 101172,
        },
        {
          id: '1444',
          name: 'Bernie O’ Boyle',
          score: 770,
          position: 205,
          time: 109254,
        },
        {
          id: '1584',
          name: 'Roland Fesselhofer',
          score: 770,
          position: 206,
          time: 112153,
        },
        {
          id: '1669',
          name: 'Michael James',
          score: 765,
          position: 207,
          time: 51077,
        },
        {
          id: '1445',
          name: 'Ryan Elliot',
          score: 765,
          position: 208,
          time: 60650,
        },
        {
          id: '1285',
          name: 'Jonathan Winn',
          score: 765,
          position: 209,
          time: 60712,
        },
        {
          id: '1872',
          name: 'Bill Melville',
          score: 765,
          position: 210,
          time: 61465,
        },
        {
          id: '1816',
          name: 'Yuki Nitami',
          score: 765,
          position: 211,
          time: 61811,
        },
        {
          id: '1707',
          name: 'Pierre Erbland',
          score: 765,
          position: 212,
          time: 61935,
        },
        {
          id: '1416',
          name: 'Theo Fleurent',
          score: 765,
          position: 213,
          time: 62184,
        },
        {
          id: '1840',
          name: 'Masamichi Onishi',
          score: 765,
          position: 214,
          time: 62623,
        },
        {
          id: '1506',
          name: 'Zoe Walsh',
          score: 765,
          position: 215,
          time: 105316,
        },
        {
          id: '1630',
          name: 'David Todd',
          score: 760,
          position: 216,
          time: 53629,
        },
        {
          id: '1836',
          name: 'Pierre Lataste',
          score: 760,
          position: 217,
          time: 65211,
        },
        {
          id: '1611',
          name: 'Alice Pieters',
          score: 760,
          position: 218,
          time: 69394,
        },
        {
          id: '1843',
          name: 'David Mitchell',
          score: 760,
          position: 219,
          time: 70643,
        },
        {
          id: '1129',
          name: 'Scott Collier',
          score: 760,
          position: 220,
          time: 111713,
        },
        {
          id: '1035',
          name: 'Tamsin Moran',
          score: 760,
          position: 221,
          time: 114889,
        },
        {
          id: '1094',
          name: 'Ula Trykozko',
          score: 760,
          position: 222,
          time: 117189,
        },
        {
          id: '1201',
          name: 'Clive Wilkinson',
          score: 755,
          position: 223,
          time: 66838,
        },
        {
          id: '1855',
          name: 'Richard Sansbury',
          score: 755,
          position: 224,
          time: 169055,
        },
        {
          id: '1317',
          name: 'Kirsten Robertson',
          score: 750,
          position: 225,
          time: 21013,
        },
        {
          id: '1042',
          name: 'Alison Matheson',
          score: 750,
          position: 226,
          time: 25254,
        },
        {
          id: '1040',
          name: 'Sandra Mather',
          score: 750,
          position: 227,
          time: 27457,
        },
        {
          id: '1058',
          name: 'Karen Ashworth',
          score: 750,
          position: 228,
          time: 32202,
        },
        {
          id: '1082',
          name: 'Evelyn Elmes',
          score: 750,
          position: 229,
          time: 35294,
        },
        {
          id: '1144',
          name: 'Lindsey King',
          score: 750,
          position: 230,
          time: 61298,
        },
        {
          id: '1180',
          name: 'Elizabeth Furness',
          score: 750,
          position: 231,
          time: 70437,
        },
        {
          id: '1858',
          name: 'David Roy',
          score: 750,
          position: 232,
          time: 72875,
        },
        {
          id: '1225',
          name: 'Andy Robinson',
          score: 750,
          position: 233,
          time: 74930,
        },
        {
          id: '1399',
          name: 'Mykyta Chubynsky',
          score: 750,
          position: 234,
          time: 75886,
        },
        {
          id: '1716',
          name: 'Timothy Evans',
          score: 750,
          position: 235,
          time: 78253,
        },
        {
          id: '1885',
          name: 'Gerardo Garcia',
          score: 750,
          position: 236,
          time: 80782,
        },
        {
          id: '1189',
          name: 'Liz Phillips',
          score: 750,
          position: 237,
          time: 120522,
        },
        {
          id: '1842',
          name: 'Ivaylo Mandev',
          score: 745,
          position: 238,
          time: 29544,
        },
        {
          id: '1450',
          name: 'Janette McHendry',
          score: 745,
          position: 239,
          time: 35786,
        },
        {
          id: '1543',
          name: 'Violet Evans',
          score: 745,
          position: 240,
          time: 37529,
        },
        {
          id: '1723',
          name: 'Anna Wartewig',
          score: 745,
          position: 241,
          time: 37871,
        },
        {
          id: '1766',
          name: 'Rosie Shaw',
          score: 745,
          position: 242,
          time: 73489,
        },
        {
          id: '1552',
          name: 'Anya Crocker',
          score: 745,
          position: 243,
          time: 83835,
        },
        {
          id: '1157',
          name: 'Cathy McComb',
          score: 745,
          position: 244,
          time: 84465,
        },
        {
          id: '1569',
          name: 'Franz Glaner',
          score: 745,
          position: 245,
          time: 85065,
        },
        {
          id: '1776',
          name: 'Andy Paterson',
          score: 745,
          position: 246,
          time: 133993,
        },
        {
          id: '1644',
          name: 'Christine King',
          score: 740,
          position: 247,
          time: 41132,
        },
        {
          id: '1165',
          name: 'Andrew Evans',
          score: 740,
          position: 248,
          time: 85862,
        },
        {
          id: '1316',
          name: 'David Robertson',
          score: 740,
          position: 249,
          time: 87760,
        },
        {
          id: '1651',
          name: 'Roger Thetford',
          score: 740,
          position: 250,
          time: 92533,
        },
        {
          id: '1641',
          name: 'Leah Bartlett',
          score: 740,
          position: 251,
          time: 127261,
        },
        {
          id: '1251',
          name: 'Steffen Hartmann',
          score: 735,
          position: 252,
          time: 45254,
        },
        {
          id: '1043',
          name: 'Alasdair Raynor',
          score: 735,
          position: 253,
          time: 45346,
        },
        {
          id: '1081',
          name: 'Pat Moody',
          score: 735,
          position: 254,
          time: 45981,
        },
        {
          id: '1121',
          name: 'James Errington',
          score: 735,
          position: 255,
          time: 47336,
        },
        {
          id: '1254',
          name: 'Rhona Fraser',
          score: 735,
          position: 256,
          time: 48304,
        },
        {
          id: '1705',
          name: 'Hugo Kindborn',
          score: 735,
          position: 257,
          time: 48357,
        },
        {
          id: '1131',
          name: 'Alexander Soulsby',
          score: 735,
          position: 258,
          time: 80268,
        },
        {
          id: '1127',
          name: 'Elaine Sutton',
          score: 735,
          position: 259,
          time: 137885,
        },
        {
          id: '1199',
          name: 'Rune De Clercq',
          score: 735,
          position: 260,
          time: 147381,
        },
        {
          id: '1607',
          name: 'Jamie Lightfoot',
          score: 730,
          position: 261,
          time: 44417,
        },
        {
          id: '1029',
          name: 'Niamh Hunter',
          score: 730,
          position: 262,
          time: 45555,
        },
        {
          id: '1133',
          name: 'Maggie Soulsby',
          score: 730,
          position: 263,
          time: 46149,
        },
        {
          id: '1159',
          name: 'Ewan Shingler',
          score: 730,
          position: 264,
          time: 46992,
        },
        {
          id: '1143',
          name: 'Joey Hadorn',
          score: 730,
          position: 265,
          time: 47121,
        },
        {
          id: '1250',
          name: 'Miranda Mackereth',
          score: 730,
          position: 266,
          time: 47259,
        },
        {
          id: '1738',
          name: 'Tatsuki Miyamoto',
          score: 730,
          position: 267,
          time: 50628,
        },
        {
          id: '1560',
          name: 'Peter Suba',
          score: 730,
          position: 268,
          time: 51884,
        },
        {
          id: '1813',
          name: 'Julie Collins',
          score: 730,
          position: 269,
          time: 52482,
        },
        {
          id: '1854',
          name: 'Matt Brierley',
          score: 730,
          position: 270,
          time: 52696,
        },
        {
          id: '1181',
          name: 'Tommy Burke',
          score: 730,
          position: 271,
          time: 88450,
        },
        {
          id: '1847',
          name: 'Jane Yates',
          score: 730,
          position: 272,
          time: 96725,
        },
        {
          id: '1246',
          name: 'Ken Walker Jr',
          score: 730,
          position: 273,
          time: 99945,
        },
        {
          id: '1294',
          name: 'Jackie Hallett',
          score: 730,
          position: 274,
          time: 140099,
        },
        {
          id: '1433',
          name: 'Sheila Strain',
          score: 730,
          position: 275,
          time: 197848,
        },
        {
          id: '1158',
          name: 'Tam Wilson',
          score: 725,
          position: 276,
          time: 51591,
        },
        {
          id: '1821',
          name: 'Tori Borish',
          score: 725,
          position: 277,
          time: 98428,
        },
        {
          id: '1688',
          name: 'Bruno Plumey',
          score: 725,
          position: 278,
          time: 99665,
        },
        {
          id: '1863',
          name: 'Samuel New',
          score: 725,
          position: 279,
          time: 144199,
        },
        {
          id: '1527',
          name: 'Andrew Campbell',
          score: 725,
          position: 280,
          time: 149388,
        },
        {
          id: '1609',
          name: 'Kotomi Ibe',
          score: 725,
          position: 281,
          time: 152949,
        },
        {
          id: '1824',
          name: 'Aoife Elise',
          score: 720,
          position: 282,
          time: 50012,
        },
        {
          id: '1051',
          name: 'Calum Robertson',
          score: 720,
          position: 283,
          time: 53719,
        },
        {
          id: '1823',
          name: 'Lukas Gasser',
          score: 720,
          position: 284,
          time: 59824,
        },
        {
          id: '1148',
          name: 'Boris Granovskiy',
          score: 720,
          position: 285,
          time: 102431,
        },
        {
          id: '1679',
          name: 'Matthew Morris',
          score: 715,
          position: 286,
          time: 58326,
        },
        {
          id: '1622',
          name: 'Rachel Wilson',
          score: 715,
          position: 287,
          time: 61726,
        },
        {
          id: '1874',
          name: 'Ian Hylton',
          score: 715,
          position: 288,
          time: 61818,
        },
        {
          id: '1315',
          name: 'Harry McMurtrie',
          score: 715,
          position: 289,
          time: 66416,
        },
        {
          id: '1208',
          name: 'Raphael Combe',
          score: 715,
          position: 290,
          time: 94987,
        },
        {
          id: '1309',
          name: 'Nicola  Melville',
          score: 715,
          position: 291,
          time: 98673,
        },
        {
          id: '1721',
          name: 'Haruki Ohashi',
          score: 715,
          position: 292,
          time: 104632,
        },
        {
          id: '1028',
          name: 'Murray Strain',
          score: 715,
          position: 293,
          time: 108120,
        },
        {
          id: '1104',
          name: 'Tamas Barany',
          score: 715,
          position: 294,
          time: 110485,
        },
        {
          id: '1448',
          name: 'Jon Hateley',
          score: 715,
          position: 295,
          time: 111329,
        },
        {
          id: '1829',
          name: 'Steve Robertson',
          score: 715,
          position: 296,
          time: 112620,
        },
        {
          id: '1575',
          name: 'Iain Shepherd',
          score: 715,
          position: 297,
          time: 113321,
        },
        {
          id: '1212',
          name: 'Alistair Duguid',
          score: 710,
          position: 298,
          time: 60719,
        },
        {
          id: '1690',
          name: 'Olmo Combley',
          score: 710,
          position: 299,
          time: 62931,
        },
        {
          id: '1023',
          name: 'Kirstin Maxwell',
          score: 710,
          position: 300,
          time: 65618,
        },
        {
          id: '1351',
          name: 'Robin Culshaw',
          score: 710,
          position: 301,
          time: 66738,
        },
        {
          id: '1533',
          name: 'Paul Furness',
          score: 710,
          position: 302,
          time: 69413,
        },
        {
          id: '1130',
          name: 'Anne Edwards',
          score: 710,
          position: 303,
          time: 74071,
        },
        {
          id: '1355',
          name: 'Gabriella Walsh',
          score: 710,
          position: 304,
          time: 113769,
        },
        {
          id: '1746',
          name: 'Matthieu Puech',
          score: 710,
          position: 305,
          time: 114441,
        },
        {
          id: '1577',
          name: "Daire O'Brien",
          score: 705,
          position: 306,
          time: 68535,
        },
        {
          id: '1497',
          name: 'Nigel Britton',
          score: 705,
          position: 307,
          time: 169782,
        },
        {
          id: '1030',
          name: 'Isaac Hunter',
          score: 700,
          position: 308,
          time: 25794,
        },
        {
          id: '1593',
          name: 'Penelope Salmon',
          score: 700,
          position: 309,
          time: 32975,
        },
        {
          id: '1699',
          name: 'Justine Edwards',
          score: 700,
          position: 310,
          time: 66961,
        },
        {
          id: '1849',
          name: 'Caroline Brammer',
          score: 700,
          position: 311,
          time: 71270,
        },
        {
          id: '1879',
          name: 'Pippa Dakin',
          score: 700,
          position: 312,
          time: 79682,
        },
        {
          id: '1579',
          name: 'Al McCartney',
          score: 695,
          position: 313,
          time: 72117,
        },
        {
          id: '1671',
          name: 'Philip Craven',
          score: 695,
          position: 314,
          time: 72801,
        },
        {
          id: '1070',
          name: 'Simon Kippin',
          score: 695,
          position: 315,
          time: 77870,
        },
        {
          id: '1814',
          name: 'Robyn Stanyon',
          score: 695,
          position: 316,
          time: 81492,
        },
        {
          id: '1750',
          name: 'Alison Cunningham',
          score: 695,
          position: 317,
          time: 128363,
        },
        {
          id: '1845',
          name: 'David Jukes',
          score: 695,
          position: 318,
          time: 180538,
        },
        {
          id: '1882',
          name: 'Matthew Fortes',
          score: 695,
          position: 319,
          time: 182043,
        },
        {
          id: '1301',
          name: 'Sebastian Ordoñez',
          score: 695,
          position: 320,
          time: 232758,
        },
        {
          id: '1754',
          name: 'Camilla Davies',
          score: 690,
          position: 321,
          time: 74771,
        },
        {
          id: '1689',
          name: 'Eoin Sharkey',
          score: 690,
          position: 322,
          time: 85319,
        },
        {
          id: '1820',
          name: 'Andrew Ward',
          score: 690,
          position: 323,
          time: 85786,
        },
        {
          id: '1862',
          name: 'Sarah Wimberley',
          score: 690,
          position: 324,
          time: 88582,
        },
        {
          id: '1852',
          name: 'Andrew Elwood',
          score: 690,
          position: 325,
          time: 94838,
        },
        {
          id: '1200',
          name: 'Sally Wilkinson',
          score: 690,
          position: 326,
          time: 126469,
        },
        {
          id: '1864',
          name: 'Pierre Bordet',
          score: 690,
          position: 327,
          time: 133220,
        },
        {
          id: '1839',
          name: 'Nicolas Corvo Weinbach',
          score: 690,
          position: 328,
          time: 137269,
        },
        {
          id: '1240',
          name: 'Philip Cooper',
          score: 690,
          position: 329,
          time: 138215,
        },
        {
          id: '1772',
          name: 'Sean Hassett',
          score: 685,
          position: 330,
          time: 39652,
        },
        {
          id: '1312',
          name: 'Nikki Howard',
          score: 685,
          position: 331,
          time: 45977,
        },
        {
          id: '1835',
          name: 'Ben Squire',
          score: 685,
          position: 332,
          time: 82819,
        },
        {
          id: '1834',
          name: 'Anthony Squire',
          score: 685,
          position: 333,
          time: 95517,
        },
        {
          id: '1742',
          name: 'Emma Granich',
          score: 685,
          position: 334,
          time: 142194,
        },
        {
          id: '1318',
          name: 'Mathieu Kern-Gillard',
          score: 680,
          position: 335,
          time: 91055,
        },
        {
          id: '1177',
          name: 'Martin Ward',
          score: 680,
          position: 336,
          time: 145802,
        },
        {
          id: '1817',
          name: 'Derek Allison',
          score: 680,
          position: 337,
          time: 148169,
        },
        {
          id: '1176',
          name: 'Esther Revell',
          score: 675,
          position: 338,
          time: 51044,
        },
        {
          id: '1489',
          name: 'Cristina Luis',
          score: 675,
          position: 339,
          time: 95280,
        },
        {
          id: '1437',
          name: 'Alison Fryer',
          score: 675,
          position: 340,
          time: 152114,
        },
        {
          id: '1511',
          name: 'Helen Chiswell',
          score: 675,
          position: 341,
          time: 152191,
        },
        {
          id: '1632',
          name: 'Finlay Anderson',
          score: 670,
          position: 342,
          time: 44826,
        },
        {
          id: '1656',
          name: 'Lise Frigault',
          score: 670,
          position: 343,
          time: 57718,
        },
        {
          id: '1631',
          name: 'Debbie Anderson',
          score: 670,
          position: 344,
          time: 162786,
        },
        {
          id: '1259',
          name: 'Emily Rowe',
          score: 665,
          position: 345,
          time: 56500,
        },
        {
          id: '1010',
          name: 'Laura King',
          score: 665,
          position: 346,
          time: 110597,
        },
        {
          id: '1263',
          name: 'Matthew Rooke',
          score: 665,
          position: 347,
          time: 161112,
        },
        {
          id: '1486',
          name: 'Dave Murgatroyd',
          score: 665,
          position: 348,
          time: 164028,
        },
        {
          id: '1151',
          name: 'Paul Hammond',
          score: 660,
          position: 349,
          time: 116854,
        },
        {
          id: '1815',
          name: 'Kieran Devine',
          score: 660,
          position: 350,
          time: 116940,
        },
        {
          id: '1564',
          name: 'Steve McLean',
          score: 655,
          position: 351,
          time: 66908,
        },
        {
          id: '1319',
          name: 'Iain Smith',
          score: 655,
          position: 352,
          time: 114454,
        },
        {
          id: '1540',
          name: 'David Currie',
          score: 655,
          position: 353,
          time: 118781,
        },
        {
          id: '1722',
          name: 'Stephen Jackson',
          score: 650,
          position: 354,
          time: 121022,
        },
        {
          id: '1884',
          name: 'Mashoto Makgatho',
          score: 640,
          position: 355,
          time: 42552,
        },
        {
          id: '1859',
          name: 'Diana Nicoll',
          score: 640,
          position: 356,
          time: 82830,
        },
        {
          id: '1032',
          name: 'Georgia Jones',
          score: 640,
          position: 357,
          time: 83121,
        },
        {
          id: '1441',
          name: 'Harriet Burdett',
          score: 640,
          position: 358,
          time: 86567,
        },
        {
          id: '1528',
          name: 'Daniel Campbell',
          score: 640,
          position: 359,
          time: 194197,
        },
        {
          id: '1566',
          name: 'Martin Cook',
          score: 635,
          position: 360,
          time: 84594,
        },
        {
          id: '1640',
          name: 'Joseph Bartlett',
          score: 630,
          position: 361,
          time: 140863,
        },
        {
          id: '1799',
          name: 'Garry Morrison',
          score: 625,
          position: 362,
          time: 95836,
        },
        {
          id: '1774',
          name: 'John Marshall',
          score: 625,
          position: 363,
          time: 152179,
        },
        {
          id: '1587',
          name: 'Jon Hollingdale',
          score: 620,
          position: 364,
          time: 109186,
        },
        {
          id: '1279',
          name: 'Glen Richardson',
          score: 620,
          position: 365,
          time: 154868,
        },
        {
          id: '1379',
          name: 'Jamie Austin-Mills',
          score: 615,
          position: 366,
          time: 65783,
        },
        {
          id: '1033',
          name: 'Matthias Mahr',
          score: 615,
          position: 367,
          time: 109622,
        },
        {
          id: '1873',
          name: 'Oli Warlow',
          score: 610,
          position: 368,
          time: 207583,
        },
        {
          id: '1233',
          name: 'Robert Finch',
          score: 605,
          position: 369,
          time: 124133,
        },
        {
          id: '1827',
          name: 'Seiya Morikiyo',
          score: 600,
          position: 370,
          time: 177634,
        },
        {
          id: '1271',
          name: 'Garry Greenstreet',
          score: 595,
          position: 371,
          time: 229977,
        },
        {
          id: '1639',
          name: 'Patrick Bartlett',
          score: 595,
          position: 372,
          time: 237463,
        },
        {
          id: '1837',
          name: 'Jana Lataste',
          score: 590,
          position: 373,
          time: 89599,
        },
        {
          id: '1833',
          name: 'Erin Weatherstone',
          score: 590,
          position: 374,
          time: 91399,
        },
        {
          id: '1803',
          name: 'Peter Reitsema',
          score: 580,
          position: 375,
          time: 202836,
        },
        {
          id: '1142',
          name: 'Mike Smithard',
          score: 570,
          position: 376,
          time: 110702,
        },
        {
          id: '1740',
          name: 'Michael Murray',
          score: 570,
          position: 377,
          time: 153344,
        },
        {
          id: '1844',
          name: 'Ann Mitchell',
          score: 565,
          position: 378,
          time: 156846,
        },
        {
          id: '1209',
          name: 'Carol Edwards',
          score: 565,
          position: 379,
          time: 262637,
        },
        {
          id: '1039',
          name: 'Dylan Sherman',
          score: 550,
          position: 380,
          time: 129742,
        },
        {
          id: '1730',
          name: 'David Gray',
          score: 545,
          position: 381,
          time: 182437,
        },
        {
          id: '1249',
          name: 'Jianhao Chen',
          score: 530,
          position: 382,
          time: 351215,
        },
        {
          id: '1871',
          name: 'Claudio Moran',
          score: 485,
          position: 383,
          time: 197222,
        },
        {
          id: '1826',
          name: 'Penny Rodgers',
          score: 385,
          position: 384,
          time: 346968,
        },
      ],
      sortBy: 'pos',
      sortDirection: 'ASC',
    }
  },

  computed: {
    finishedUsers: function() {
      return this.users.filter(user => user?.score)
    },

    usersWithPosition: function() {
      const sortedUsers = this.finishedUsers
        ?.sort((a, b) => {
          if (a.time === b.time) return 0
          else if (a.time < b.time) return -1
          else return 1
        })
        ?.sort((a, b) => {
          if (a.score === b.score) return 0
          else if (a.score < b.score) return 1
          else return -1
        })

      let lastScore = 0
      let lastTime = 0
      let position = 0
      let numberIdentical = 0

      for (const user of sortedUsers) {
        if (user.score !== lastScore && user.time !== lastTime) {
          position += numberIdentical + 1
          numberIdentical = 0
        }
        if (user.score === lastScore && user.time === lastTime)
          numberIdentical += 1

        user.position = position
      }

      return sortedUsers
    },

    sortedUsers: function() {
      const sortBy = this.sortBy

      const sortedUsers = this.usersWithPosition.sort((a, b) => {
        if (a[sortBy] === b[sortBy]) return 0
        else if (a[sortBy] === null || a[sortBy] === undefined) return 1
        else if (b[sortBy] === null || b[sortBy] === undefined) return -1
        else if (a[sortBy] < b[sortBy]) return 1
        else return -1
      })

      if (this.sortDirection === 'ASC') return sortedUsers
      else return sortedUsers.reverse()
    },

    consoleUsers: function() {
      const b = this.sortedUsers.map(doc => ({
        id: doc.id,
        name: doc.name,
        score: doc.score,
        position: doc.position,
        time: doc.time,
      }))
      console.log(JSON.stringify(b))
      let a = 'position, racenumber, name, score, time'
      const sortedUsers = [...new Set(this.sortedUsers)]
      for (const user of sortedUsers) {
        a += `\n${user.position}, ${user.id}, ${user.name}, ${
          user.score
        }, ${this.displayTime(user.time)}`
      }
      console.log(a)

      return a
    },
  },

  mounted: function() {
    /*
    this.users = await db
      .collection('classic')
      .where('startedForest', '==', true)
      .get()
      .then(result =>
        result?.docs
          ?.map(doc => ({
            id: doc.id,
            ...doc.data(),
          }))
          ?.filter(doc => doc.id > 500)
          ?.map(doc => ({
            ...doc,
            time: doc.forestTime,
            score: doc.forestScore,
          }))
      )
*/
    /*
    await db
      .collection('teams')
      .where('startedMemory', '==', true)
      .get()
      .then(result =>
        console.log(
          JSON.stringify(
            result?.docs?.map(doc => ({
              id: doc.id,
              ...doc.data(),
            }))
          )
        )
      ) */
    /*
    db.collection('wod')
      .doc('1180')
      .update({ started: false })
      .then(() => console.log('reset'))
      .catch(() => console.log('fail'))
*/
    /*
    await db
      .collection('wod')
      .doc('3230')
      .update({
        trailTime: 102664,
        startedTrail: true,
        score: 4,
        time: 560350,
      })
      .then(() => console.log('reset'))
      .catch(() => console.log('fail'))

    await db
      .collection('wod')
      .doc('3230')
      .get()
      .then(doc => console.log(doc.data()))

    /*
    db.collection('wod')
      .doc('3202')
      .set({ name: 'nik Weber' })
      .then(()=>console.log('done'))
    */
  },

  methods: {
    changeSortBy: function(field) {
      if (this.sortBy === field && this.sortDirection === 'ASC')
        this.sortDirection = 'DESC'
      else if (this.sortBy === field) this.sortDirection = 'ASC'
      this.sortBy = field
    },

    displayTime: function(milliseconds) {
      const minutes = Math.floor(milliseconds / 60000)
      const millisecondsOverMinutes = milliseconds - minutes * 60000
      const seconds = Math.round(millisecondsOverMinutes / 10) / 100

      return `${this.twoDigits(minutes)}:${this.twoDigits(seconds)}`
    },

    twoDigits: function(number) {
      const splitNumber = number.toString().split('.')
      if (splitNumber.length > 1 && splitNumber[0].toString().length < 2)
        return `0${splitNumber[0].toString()}.${splitNumber[1]}`
      else if (number.toString().length < 2) return `0${number.toString()}`
      else return number
    },

    scoreUser: function(choices, times) {
      let correct = 0
      let score = 0
      console.log('scoreUser')
      const solution = [
        ['A', 'B'],
        ['B', 'D'],
        ['B'],
        ['A'],

        ['C'],
        ['B', 'D'],
        ['B', 'C'],

        ['B', 'C'],
        ['A', 'B'],
        ['C'],
      ]

      let i = 0
      while (i < choices.length) {
        let time = times[i]
        // if (time > 5000 && time < 10000) time -= 5000
        if (solution[i].includes(choices[i]))
          score = 100 - Math.floor(time / 5000) * 5
        else score = 50 - Math.floor(time / 5000) * 5

        if (score > 0) correct += score

        i += 1
      }
      return correct
    },
  },
}
</script>
<style>
table {
  width: 80%;
  margin-left: 10%;
  margin-right: 10%;
}

tr {
  transition: 0.3s;
}

tbody tr:nth-child(odd) {
  background-color: #ebf8ff;
}

td,
th {
  padding: 0.5rem;
}

th {
  user-select: none;
}
</style>
